import React, { useState, useEffect } from "react";
import {
  Typography,
  Card,
  CardContent,
  Tabs,
  Box,
  Button,
  Tab,
  IconButton,
  Icon,
  ListItemText,
  Select as MUISelect,
  Grid
} from "@material-ui/core";
import { useQuery } from "@apollo/client";
// import CloseIcon from "@material-ui/icons/Close";
import { useSelector, connect } from "react-redux";
// import moment from "moment";
// import PriceList from "./PriceList";
import PlainsInUseList from "./PlansInUseList";
import ModuleFunctionalityList from "./ModuleFunctionalityList";
// import { industryQuery } from "../plans/signupPlansGQLQuery";
import {
  getModuleByIdQuery,
  modulesFunctionalityByModuleIdQuery
  // signupPlanResourcesBySignupPlanIdRootQuery,
} from "./ModulesGqlQuery";
import Spinner from "../common/Spinner";
import { v4 as uuidv4 } from "uuid";

function TabPanel(props) {
  const { children, value, index, ...other } = props;
  return (
    <Typography
      component="div"
      role="tabpanel"
      hidden={value !== index}
      id={`wrapped-tabpanel-${index}`}
      aria-labelledby={`wrapped-tab-${index}`}
      {...other}
    >
      {value === index && <Box p={0}>{children}</Box>}
    </Typography>
  );
}

const ModuleDetails = (props) => {
  // const {
  //   data: moduleFunctionalityData,
  //   loading: moduleFunctionalityDataLoading,
  //   refetch: moduleFunctionalityDataRefetch,
  //   error: moduleFunctionalityDataError,
  //   fetchMore: moduleFunctionalityDataFetchMore,
  // } = useQuery(modulesFunctionalityByModuleIdQuery, {
  //   variables: {
  //     moduleId: parseInt(props.match.params.Id),
  //   },
  //   fetchPolicy: "network-only",
  // });

  let moduleFunctionalityListByModuleIdRootQueryRefetchOnCall = () => {};

  let plansByModuleIdRootQueryRefetchOnCall = () => {};

  const {
    data: moduleByIdQueryData,
    loading: moduleByIdQueryLoading
  } = useQuery(getModuleByIdQuery, {
    variables: {
      id: parseInt(props.match.params.Id)
    },
    fetchPolicy: "network-only"
  });

  useEffect(() => {
    if (moduleByIdQueryData && moduleByIdQueryData.moduleByIdQuery) {
      setModuleDetails(moduleByIdQueryData.moduleByIdQuery);
    } else {
      setModuleDetails([]);
    }
    // if (
    //   moduleFunctionalityData &&
    //   moduleFunctionalityData.modulesFunctionalityByModuleId &&
    //   moduleFunctionalityData.modulesFunctionalityByModuleId.modulesFunctionality
    // ) {
    //   setModuleList(
    //     moduleFunctionalityData.modulesFunctionalityByModuleId.modulesFunctionality
    //   );
    // } else {
    //   setModuleList([]);
    // }
  }, [
    moduleByIdQueryData
    // moduleFunctionalityData
  ]);

  const [moduleDetails, setModuleDetails] = useState([]);
  // const [moduleList, setModuleList] = useState([]);
  const [dataVersion, setDataVersion] = useState(uuidv4());
  const [selectedTab, setSelectedTab] = useState("modules");

  const handleTabChange = (event, value) => {
    setSelectedTab(value);
  };
  var height = window.innerHeight - 105;

  const goBack = () => {
    props.history.goBack();
    return true;
  };

  return (
    <>
      <div>
        <IconButton
          style={{
            color: "#387DFF",
            zIndex: 9999,
            top: 9,
            position: "absolute"
          }}
          onClick={goBack}
        >
          <Icon fontSize="small">arrow_back</Icon>
        </IconButton>
      </div>
      <div style={{ height: height }}>
        <Grid direction="column" container spacing={2}>
          {moduleByIdQueryLoading && <Spinner />}
          <Grid item xs={12}>
            <Card className="cardContentWraper">
              <CardContent>
                <Grid container direction="row" spacing={2}>
                  {moduleDetails && (
                    <Grid container spacing={2}>
                      <Grid item xs={4}>
                        <ListItemText
                          className="cardListItem"
                          primary={
                            <Typography
                              variant="caption"
                              className="cardItemprimary"
                            >
                              {"Module Name"}
                            </Typography>
                          }
                          secondary={
                            <Typography className="cardItemsecondary">
                              {moduleDetails && moduleDetails.moduleName}
                            </Typography>
                          }
                        />
                      </Grid>
                      <Grid item xs={4}>
                        <ListItemText
                          className="cardListItem"
                          primary={
                            <Typography
                              variant="caption"
                              className="cardItemprimary"
                            >
                              {"Display Name"}
                            </Typography>
                          }
                          secondary={
                            <Typography className="cardItemsecondary">
                              {moduleDetails && moduleDetails.moduleDisplayName}
                            </Typography>
                          }
                        />
                      </Grid>
                    </Grid>
                  )}
                </Grid>
              </CardContent>
            </Card>
          </Grid>
          <Grid item xs={12}>
            <Card
              className="cardContentWraper tabsWraper"
              style={{ height: height - 90 }}
            >
              <CardContent>
                <div className="tabsWraperHeader">
                  <Tabs
                    value={selectedTab}
                    onChange={handleTabChange}
                    indicatorColor="primary"
                    textColor="primary"
                    variant="scrollable"
                    scrollButtons="off"
                    style={{ padding: 0 }}
                    className="settingTabsHeaderTitle"
                  >
                    <Tab value="modules" label="Module Functionality" />
                    <Tab value="plansInUse" label="Plans in used" />
                  </Tabs>
                </div>
                <TabPanel value={selectedTab} index="modules">
                  <div style={{ position: "relative" }} className="p-16">
                    <ModuleFunctionalityList
                      moduleFunctionalityListByModuleIdRootQueryRefetchOnCall={async (
                        ev
                      ) => {
                        moduleFunctionalityListByModuleIdRootQueryRefetchOnCall = ev;
                      }}
                      dataVersion={dataVersion}
                      moduleId={props.match.params.Id}
                      height={height - 125}
                    />
                  </div>
                </TabPanel>
                <TabPanel value={selectedTab} index="plansInUse">
                  <div style={{ position: "relative" }} className="p-16">
                    <PlainsInUseList
                      bindPlansByModuleIdRootQueryRefetchOnCall={async (ev) => {
                        plansByModuleIdRootQueryRefetchOnCall = ev;
                      }}
                      dataVersion={dataVersion}
                      moduleId={props.match.params.Id}
                      height={height - 150}
                    />
                  </div>
                </TabPanel>
              </CardContent>
            </Card>
          </Grid>
        </Grid>
      </div>
    </>
  );
};

const mapStateToProps = ({}) => {
  return {};
};
export default connect(mapStateToProps)(ModuleDetails);
